import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { Dialog } from '../../components';
import { revokeAdmin } from '../../mutations';

export class AdminCellView extends Component {
  state = {
    showsRevokeDialog: false,
  };

  handleRevokeClicked = () => {
    this.setState({ showsRevokeDialog: true });
  };

  handleCancelRevoke = () => {
    this.setState({ showsRevokeDialog: false });
  };

  handleConfirmRevoke = () => {
    this.setState({ showsRevokeDialog: false });

    const { lists, user, relay } = this.props;
    revokeAdmin(relay.environment, user.id, lists.id);
  };

  render() {
    const { showsRevokeDialog } = this.state;
    const { user } = this.props;

    return (
      <tr className="admin-cell">
        <td className="admin-cell-email">
          <Dialog
            className="deletion"
            isOpen={showsRevokeDialog}
            message={`Are you sure you want to revoke admin access for ${user.email}?`}
            onConfirm={this.handleConfirmRevoke}
            onCancel={this.handleCancelRevoke}
          />
          <span>{user.email}</span>
          <a className="admin-revoke-button" onClick={this.handleRevokeClicked}>
            ✘
          </a>
        </td>
      </tr>
    );
  }
}

export default createFragmentContainer(AdminCellView, {
  lists: graphql`
    fragment AdminCell_lists on Lists {
      id
    }
  `,
  user: graphql`
    fragment AdminCell_user on User {
      id
      email
    }
  `,
});
